export const createRoute = (router, path, title, icon, permission) => ({
    path,
    name: `${router}-mall-${path}`,
    component: () => import("@/views/fms/mall/goods.vue"),
    hidden: path === "", // 全部产品不展示到menu
    meta: {
        title,
        icon,
        key: path,
        affix: false,
        keepAlive: true,
        permission,
    },
});
